import React, {useState} from 'react';
import {isMobile} from "../commonmethod/CommonMethod";
import NoSelected from "../Utils/NoSelected";

function RecursiveListComponent({top, list, info, target, setTarget}) {
    return (
        <div className={"flex w-full"}>
            <div className={`w-2/6  ${isMobile ? '' : 'p-3 mt-3' }  overflow-y-auto code-height`}>
                <>{top}</>

                {list ?
                    <div className="compo-list2">
                        {list}
                    </div>
                    :
                    <div className="border-r-gray compo-list">
                        <span className="text-center h-[200px] bg-white-gray">데이터가 없습니다.</span>
                    </div>
                }

            </div>

            {isMobile && target &&
                <div className={`mobile-showup-background`} onClick={()=>setTarget(null)}><p>awdawd</p></div>
            }

            <div className={`border w-4/6 p-[1rem] ${isMobile ? 'mobile-view-container' : 'm-3 code-info code-height'}  ${target? 'show-up':''} w-full`}>
                {info ?
                    <>{info}</>
                    :
                    <>
                        <NoSelected height={500} title={"대상을 선택하세요"}/>
                    </>
                }
            </div>

        </div>
    );
}

export default RecursiveListComponent;